import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'petastiChamiliElafronApostrofos';
const args = {};

export class PetastiChamiliElafronApostrofos extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
